import getNotificationTranslations from "@casino/actions/notifications/getNotificationTranslations";
import isTranslationKey from "@casino/shared/utils/notificationText/isTranslationKey";
import resolveNotificationText from "@casino/shared/utils/notificationText/resolveNotificationText";
import { datadogRum } from "@datadog/browser-rum";
import { useEffect, useState } from "react";

type Args = {
  title?: string;
  body?: string;
  notificationId?: string;
};

const useNotificationText = ({ title, body, notificationId }: Args) => {
  const keys = [title, body].filter(isTranslationKey).map((key) => key.trim());
  const joinedKeys = keys.join(",");
  const [translations, setTranslations] = useState<Record<string, string>>();

  useEffect(() => {
    if (!joinedKeys) {
      return;
    }
    const keysToFetch = joinedKeys.split(",");
    getNotificationTranslations(keysToFetch, notificationId)
      .then(setTranslations)
      .catch((error) => {
        datadogRum.addError(error, { keys: keysToFetch, notificationId });
        setTranslations({});
      });
  }, [joinedKeys, notificationId]);

  return {
    isLoading: keys.length > 0 && translations === undefined,
    title: resolveNotificationText(title, translations),
    body: resolveNotificationText(body, translations),
  };
};

export default useNotificationText;
